module.exports = __webpack_public_path__ + "assets/img/icon_calendar.afb70065.svg";